import { isEqual as isEqualLodash } from "lodash";

export const isEqual = (val1: any, val2: any): boolean => {
  try {
    return isEqualLodash(val1, val2);
  } catch {
    return false;
  }
};
